import React, { useState } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import arrowUpImg from '../../../assets/img/icon-send.png';
import useMessages from '../../../hooks/useMessages';
import useNavigation from '../../../hooks/useNavigation';
import { useTranslation } from 'react-i18next';
import viewStates from "../../../helpers/viewStates";



const CommentBox = () => {
  const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  };
  const showCommentBox = true;

  const [text, setText] = useState('');
  const { t } = useTranslation();
  const { addMessage, showForm } = useMessages();
  const { setChatView, view, setInitialMessage } = useNavigation();

  const doNotUnderstandMessage = () => {
    return {
      bot: true,
      answers: [
        {
          translations: [
            {
              language: 'ET',
              text: t('message.not_understand', {lng: 'et'})
            },
            {
              language: 'RU',
              text: t('message.not_understand', {lng: 'ru'})
            },
            {
              language: 'LV',
              text: t('message.not_understand', {lng: 'lv'})

            },
            {
              language: 'EN',
              text: t('message.not_understand', {lng: 'en'})

            }

          ],
          followUpAction: 'ANSWER',
        }
      ]
    };
  }

  const onClick = async () => {
    if (!text || !text.length) {
      return;
    }


    // first add a message what the user just said
    const userMessage = {
      bot: false,
      translations: [
        {
          language: 'EN',
          text: text,
        },
      ],
      followUpAction: 'ANSWER'
    };

    const userIntent = {
      bot: false,
      answers: [
        userMessage
      ]
    };

    // TODO  - unify parameters for initial and every else message
    if(view === viewStates.START){
      setInitialMessage(userMessage);
    }
    else {
      await addMessage(userIntent);
    }
    setText('');

    // ask backend
    // we render the options and add them to the array
    const { data } = await axios.post('/wit', { question: text });

    if (data.success) {
      if(data.intent?.answers?.length !== 0){
        await addMessage({
          bot: true,
          answers: data.intent.answers
        })
      }
    } else {
      await addMessage(doNotUnderstandMessage(), true);
    }
  };

  const handleKey = (event) => {
    if (event.key === 'Enter') {
      onClick();
    }
  };

  return (
    <div id="comment-box" className={classNames({
      visible: showCommentBox
    })}>
      {showCommentBox && (
        <div className="wrapper">
          <input type="text" placeholder={t('form.your_comment')} value={text} onChange={(e) => setText(e.target.value)}
                 onKeyDown={handleKey} />
          <button onClick={onClick}>
            <img src={arrowUpImg} alt="" />
          </button>
        </div>
      )}
    </div>
  );
};

export default CommentBox;
